import FormItemBigVerticalButtons from './FormItemBigVerticalButtons';

export default FormItemBigVerticalButtons;